import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import logo from '../assets/images/avyudha_logo_rm_bg.png';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <img src={logo} alt="Avyudha" className="h-10 object-contain" />
            </div>
            <p className="text-sm">
              Connecting students with qualified tutors across India. Your one-stop solution for quality education.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-blue-400 transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="hover:text-blue-400 transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="hover:text-blue-400 transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="#" className="hover:text-blue-400 transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/find-tutor" className="hover:text-blue-400 transition-colors">Find Tutor</Link></li>
              <li><Link to="/find-organisation" className="hover:text-blue-400 transition-colors">Find Organisation</Link></li>
              <li><Link to="/find-job" className="hover:text-blue-400 transition-colors">Find Job</Link></li>
              <li><Link to="/about" className="hover:text-blue-400 transition-colors">About Us</Link></li>
            </ul>
          </div>

          {/* For Tutors */}
          <div>
            <h3 className="text-white font-semibold mb-4">For Tutors</h3>
            <ul className="space-y-2">
              <li><Link to="/register-tutor" className="hover:text-blue-400 transition-colors">Register as Tutor</Link></li>
              <li><Link to="/tutor-guidelines" className="hover:text-blue-400 transition-colors">Guidelines</Link></li>
              <li><Link to="/pricing" className="hover:text-blue-400 transition-colors">Pricing</Link></li>
              <li><Link to="/faq" className="hover:text-blue-400 transition-colors">FAQ</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <MapPin className="h-5 w-5 mt-0.5 flex-shrink-0" />
                <span className="text-sm">5th floor, B hub, Maurya Lok Complex, Patna, Bihar, India - 80001</span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="h-5 w-5 flex-shrink-0" />
                <a href="mailto:info@avyudha.com" className="text-sm hover:text-blue-400 transition-colors">
                  info@avyudha.com
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="h-5 w-5 flex-shrink-0" />
                <a href="tel:+911234567890" className="text-sm hover:text-blue-400 transition-colors">
                  +91 123 456 7890
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} Avyudha Consultancy Services Pvt Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
